import { render, staticRenderFns } from "./ProjectsAdminBlock.vue?vue&type=template&id=da90c346&scoped=true&"
import script from "./ProjectsAdminBlock.vue?vue&type=script&lang=js&"
export * from "./ProjectsAdminBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsAdminBlock.vue?vue&type=style&index=0&id=da90c346&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da90c346",
  null
  
)

export default component.exports